import { createContext, useContext, useState } from 'react';
import AlertNotification from '../components/common/alert/AlertNotification';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showAlert = (message, severity = 'success') => {
    setAlertState({
      open: true,
      message,
      severity
    });
  };

  const handleClose = () => {
    setAlertState(prev => ({ ...prev, open: false }));
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <AlertNotification
        open={alertState.open}
        message={alertState.message}
        severity={alertState.severity}
        onClose={handleClose}
      />
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);